export enum CrudAction {
    GetAll = 'GET_ALL',
    Get = 'GET',
    Create = 'CREATE',
    Update = 'UPDATE',
    PartialUpdate = 'UPDATE_PARTIAL',
    Delete = 'DELETE',
    Download = 'DOWNLOAD',
    GetSum = 'GET_SUM',
    GetGrouped = 'GET_GROUPED',
    SetLatestRequestId = 'SET_LATEST_REQUEST_ID',
}

export enum CrudResponseAction {
    GetAllSuccess = 'GET_ALL_SUCCESS',
    GetAllNoop = 'GET_ALL_NOOP',
    GetAllFailed = 'GET_ALL_FAILED',
    GetSuccess = 'GET_SUCCESS',
    GetFailed = 'GET_FAILED',
    CreateSuccess = 'CREATE_SUCCESS',
    CreateFailed = 'CREATE_FAILED',
    UpdateSuccess = 'UPDATE_SUCCESS',
    UpdateFailed = 'UPDATE_FAILED',
    PartialUpdateSuccess = 'UPDATE_PARTIAL_SUCCESS',
    PartialUpdateFailed = 'UPDATE_PARTIAL_FAILED',
    DeleteSuccess = 'DELETE_SUCCESS',
    DeleteFailed = 'DELETE_FAILED',
    DownloadSuccess = 'DOWNLOAD_SUCCESS',
    DownloadFailed = 'DOWNLOAD_FAILED',
    GetSumSuccess = 'GET_SUM_SUCCESS',
    GetSumFailed = 'GET_SUM_FAILED',
    GetGroupedSuccess = 'GET_GROUPED_SUCCESS',
    GetGroupedFailed = 'GET_GROUPED_FAILED',
}
